<ng-container *ngFor="let v of values; let i = index">
  <div class="row col-12 chk-margin">
    <p-radioButton [disabled]="readonly" name="{{ name }}" [value]="v" [(ngModel)]="selectedValues" [label]="v[labelName]"></p-radioButton>
  </div>
</ng-container>
